import React from 'react';
import './Footer.scss';
import SearchBar from './Components/SearchBar/SearchBar';
import LogIn from './Components/LogIn/LogIn';
import Social from './Components/Social/Social';
import Corporate from './Components/Corporate/Corporate';
import SubNav from './Components/SubNav/SubNav';

function Footer() {
  return (
    <div className="footer">
      <div className="footer__contents">
        <SearchBar />
        <LogIn screenWidth="mobile" />
        <hr className="divider divider--m" />
        <SubNav origin="media" />
        <hr className="divider divider--m" />
        <SubNav origin="politics" />
        <Social origin="politics" />
        <hr className="divider divider--m" />
        <SubNav origin="main" />
        <hr className="divider divider" />
        <Social origin="cnn" />
        <hr className="divider divider" />
        <Corporate />
      </div>
    </div>
  );
}

export default Footer;
